<template>
    <div id="download-image">
        <div id="app-layout-right-column__content__title">
            <span>Save Image</span>
        </div>

        <div class="py-5">
            <label class="mb-2" for="name" theme="--start">Image Name - optional</label>
            <div name="export-image-name-container">
                <v-text-field
                    rounded
                    v-model="name"
                    name="name"
                    ref="name"
                    placeholder="Eg. My Image #5"
                />
            </div>

            <v-menu offset-y min-width="120" content-class="modal-menu">
                <template v-slot:activator="{ on }">
                    <div class="menu-label mb-5" v-on="on">
                        <span class="name">Format: {{ type }}</span>
                        <i class="material-icons">arrow_drop_down</i>
                    </div>
                </template>
                <v-list>
                    <v-list-item v-for="selectableType in types" :key="selectableType" @click="type = selectableType" :class="{'--selected': selectableType == type}">
                        <v-list-item-title>{{ selectableType }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <v-expansion-panels accordion :class="{'visibility-hidden': type.toLowerCase() !== 'jpg'}">
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="btn-advanced-options">
                            <span>Additional Options</span>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div id="advanced-export-options">
                            <div class="block-sliders-container">
                                <span class="slider-name option-title">Quality</span>
                                <input type="range" v-model="jpgQuality" min="50" max="100" step="1"
                                       class="range_slider adjustmentBlock-slider">
                                <input type="number" v-model="jpgQuality" class="range_value adjustmentBlock-range"
                                       name="quantity" min="50" max="100" step="1">
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <div class="buttons-container">
                <button type="button" class="button button--primary" @click="onSubmit" :disabled="exporting">
                    <v-progress-circular v-if="exporting" indeterminate color="var(--color-light)" size="18"
                                         width="3"></v-progress-circular>
                    <span v-else class="font-weight-bold">Save</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters, mapState } from "vuex";
import JSZip from "jszip";
import download from "downloadjs";

export default {
    data() {
        return {
            name: "",
            type: "JPG",
            types: ["JPG", 'PNG', 'TIFF'],
            exporting: false,
            jpgQuality: 100,
        };
    },
    computed: {
        ...mapState("Projects", ["action", "exif"]),
        ...mapState("UI", ["rightColumn", "rawDeveloped"]),
    },
    watch: {
        action(newValue) {
            if (this.action.action == "export-lut-from-asset" && this.action.data.length == 1) {
                // because on every modal show, we clear all input fields
                setTimeout(() => {
                    this.name = newValue.data[0].nicename;
                }, 200);
            }
        },

        rightColumn(newValue) {
            if (newValue == 'download-image') {
                this.$refs.name.focus();
            }
        }

    },
    methods: {
        async onSubmit() {
            this.exporting = true;

            await lutify.saveMainImage(this.type.toLowerCase(), this.name, {jpgQuality: this.jpgQuality / 100});

            this.exporting = false;
            window.UI.hideModal();
            this.name = "";
        },
    },
}
</script>

<style lang="scss">
#download-image {
    .switch-container {
        margin-left: initial;
    }

    label {
        //margin-bottom: 10px !important;
        line-height: 1;
        display: block;
        height: auto;
        padding: 0;
        font-size: 1rem;
    }

    .v-input {
        padding: 0;
        margin: 0;
    }

    .v-input__slot {
        padding: 0;
    }

    input[type="text"]{
        line-height: 20px;
        background: white;
        -webkit-appearance: none;
        border-radius: 5px;
        border: none;
        color: var(--color-bg-dark);
        padding: 7px 10px;
        //margin-bottom: 20px;
        font-size: 1rem;

        &::placeholder {
            color: var(--font-default-color);
            font-family: Poppins;
            font-size: 1rem;
        }
    }

    input[type="submit"],
    button {
        margin: 0 auto;
        outline: 0;

        &:hover {
            opacity: 0.8;
        }
    }

    .menu-label {
        display: flex;
        align-items: center;
        font-size: 13px;
        position: relative;
        .name {
            line-height: 1;
        }
        i {
            font-size: 18px;
        }
    }

    .visibility-hidden {
        visibility: hidden;
        transition: none;

        * {
            transition: none;
        }
    }

    .block-sliders-container {
        input {
            color: #989898
        }
    }

    .option-container {
        display: flex;
        align-items: center;
        gap: 1rem;

        &.--disabled {
            opacity: 0.25;

            input {
                pointer-events: none;
                cursor: not-allowed;
            }
        }

        .option-title {
            line-height: 1.25;
        }
    }

    .btn-advanced-options {
        margin-bottom: 0;

        > span {
            line-height: 20px;
        }
    }

    .description-container {
        margin-bottom: 8px;

        .v-expansion-panel-header {
            span {
                line-height: 12px;
            }
        }
    }

    div[name="export-image-name-container"] {
        input {
            background: white;
            border-radius: 5px;
            border: none;
            color: #121212;
            padding: 7px 10px;
            font-size: 1rem;
            width: 100%;

            &:disabled {
                opacity: 0.3;
                cursor: not-allowed;
            }
        }
    }

    .buttons-container {
        margin-top: 30px;
        display: flex;
        justify-content: center;
    }

    .v-expansion-panel {
        background: transparent;
        color: inherit;

        &:before {
            display: none;
        }

        .v-expansion-panel-header {
            padding: 0;
            min-height: auto;
            margin-bottom: 10px;

            &:before {
                display: none;
            }

            &__icon {
                margin-left: 5px;

                i {
                    font-size: 18px;
                    color: var(--font-default-color);
                }
            }

            & > :not(&__icon) {
                flex: initial;
            }
        }

        .v-expansion-panel-content__wrap {
            padding: 0;
        }
    }

    .warning-container {
        border-radius: var(--box-rounding);
        background: var(--color-warning);
        display: flex;
        align-items: flex-start;
        color: var(--color-bg-gray);
        padding: 1rem;
        gap: 10px;
        margin-top: 2rem;

        i {
            color: var(--color-bg-gray);
        }
    }
}

.modal-menu {
    z-index: 10 !important;
    border-radius: var(--box-rounding);
    //padding: 25px 0;
    background: var(--dark-gray);

    .v-list {
        background: var(--dark-gray);
        padding: 25px 0;

        .v-list-item {
            min-height: 20px;
            padding: 0 25px;
            //display: grid;
            //grid-template-columns: 18px 1fr 18px;
            cursor: pointer;

            &.--first {
                order: -1;
            }

            &:hover {
                background: rgb(54, 54, 54);
            }

            &.full-span {
                grid-template-columns: 1fr;
            }

            &.stars-icons-container {
                grid-template-columns: repeat(5, 1fr);
            }

            &[aria-expanded="true"] {
                background: rgb(54, 54, 54);
            }

            &.--selected {
                .material-icons,
                .v-list-item__title {
                    color: var(--primary);
                }
            }

            &.v-list-item--disabled {
                opacity: 0.6;
            }

            .material-icons {
                color: #989898;
                font-size: 18px;
                width: 18px;
            }

            .v-list-item__title {
                margin-left: 4px;
                color: #989898;
                font-size: 1rem;
            }

            &:after {
                display: none;
            }
        }
    }
}
</style>